module.exports = __webpack_public_path__ + "img/9788972976196.6c5621c8.jpg";